// hero.js — Continuous autonomous variable font animation on letter cards.
// Each card breathes on its own sine-wave rhythm; mouse pushes/pulls on top.

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var hero = document.querySelector('[data-hero]');
  if (!hero) return;

  var cards = Array.from(hero.querySelectorAll('[data-letter-card]'));
  if (!cards.length) return;

  var configs = cards.map(function (card) {
    return {
      el:     card,
      font:   card.dataset.font,
      axes:   JSON.parse(card.dataset.axes),
      defs:   JSON.parse(card.dataset.defaults),
      glyph:  card.querySelector('[data-letter-glyph]')
    };
  });

  // Golden-ratio phase spacing so cards never sync up
  var PHI = 1.6180339887;
  var rhythms = configs.map(function (_, i) {
    return {
      wf:  0.25 + (i % 5) * 0.07,                         // weight freq  0.25–0.53 Hz
      wp:  (i * PHI * Math.PI) % (Math.PI * 2),           // weight phase
      sf:  0.17 + (i % 4) * 0.06,                         // secondary freq
      sp:  (i * PHI * Math.PI * 1.4) % (Math.PI * 2)      // secondary phase
    };
  });

  var mx = 0.5, my = 0.5;
  var t = 0, lastTs = null, rafId = null;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function range(v, a, b, c, d) { return c + ((clamp(v,a,b)-a)/(b-a))*(d-c); }
  function fvs(axes, vals) {
    return Object.keys(axes).map(function(k) {
      return '"' + k + '" ' + vals[k].toFixed(2);
    }).join(', ');
  }

  function tick(ts) {
    if (lastTs !== null) t += (ts - lastTs) / 1000;
    lastTs = ts;

    var dx = mx - 0.5;   // −0.5 … +0.5
    var dy = my - 0.5;

    configs.forEach(function (cfg, i) {
      if (!cfg.glyph) return;
      var ax = cfg.axes, r = rhythms[i], v = {};

      if (ax.wght) {
        var mid = (ax.wght.min + ax.wght.max) / 2;
        var half = (ax.wght.max - ax.wght.min) / 2;
        v.wght = mid + half * clamp(Math.sin(t * r.wf * Math.PI * 2 + r.wp) + dx * 1.8, -1, 1);
      }
      if (ax.wdth) {
        var mid = (ax.wdth.min + ax.wdth.max) / 2;
        var half = (ax.wdth.max - ax.wdth.min) / 2;
        v.wdth = mid + half * clamp(Math.sin(t * r.sf * Math.PI * 2 + r.sp) + dy * 1.3, -1, 1);
      }
      if (ax.slnt) {
        v.slnt = range(clamp(Math.sin(t * r.sf * Math.PI * 2 + r.sp + 1.2) - dx, -1, 1), -1, 1, ax.slnt.min, 0);
      }
      if (ax.ital) {
        // Snaps on a slow beat — punchy contrast
        v.ital = Math.sin(t * r.wf * Math.PI * 2 * 0.4 + r.wp) > 0.1 ? ax.ital.max : ax.ital.min;
      }
      if (ax.opsz) {
        v.opsz = range(clamp(Math.sin(t * r.sf * Math.PI * 2 + r.sp + 0.7) + dy, -1, 1), -1, 1, ax.opsz.min, ax.opsz.max);
      }
      if (ax.MONO) {
        // 2× faster than weight so Sono's mono↔prop morph is clearly visible
        v.MONO = range(Math.sin(t * r.wf * Math.PI * 2 * 2.2 + r.sp), -1, 1, 0, 1);
      }

      cfg.glyph.style.fontFamily = "'" + cfg.font + "', sans-serif";
      cfg.glyph.style.fontVariationSettings = fvs(ax, v);
    });

    rafId = requestAnimationFrame(tick);
  }

  // Set initial state before first tick
  configs.forEach(function (cfg) {
    if (!cfg.glyph) return;
    cfg.glyph.style.fontFamily = "'" + cfg.font + "', sans-serif";
    cfg.glyph.style.fontVariationSettings = fvs(cfg.axes, cfg.defs);
    cfg.glyph.style.willChange = 'font-variation-settings';
  });

  document.addEventListener('mousemove', function (e) {
    mx = e.clientX / window.innerWidth;
    my = e.clientY / window.innerHeight;
  });

  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    mx = t.clientX / window.innerWidth;
    my = t.clientY / window.innerHeight;
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      cancelAnimationFrame(rafId); rafId = null; lastTs = null;
    } else {
      rafId = requestAnimationFrame(tick);
    }
  });

  rafId = requestAnimationFrame(tick);
})();
